import { TABLE_DEFAULT_COL_WIDTH } from '../../../../../../../common/table/tableConstants';

const CELL_LINE_HEIGHT_GU = 2;
const CELL_VERTICAL_PADDING_GU = 0.5;

/**
 * Returns the default rendered column width for a table at the current grid size.
 */
export const getDefaultTableColWidth = (gridSize: number) => TABLE_DEFAULT_COL_WIDTH * gridSize;

export const getDefaultTableCellLineHeight = (gridSize: number) => CELL_LINE_HEIGHT_GU * gridSize;
export const getDefaultTableCellVerticalPadding = (gridSize: number) => CELL_VERTICAL_PADDING_GU * gridSize - 0.5;
